import { useQueryClient } from "@tanstack/react-query";

import { ReviewItemFieldsFragment, useReopenReportCommentMutation } from "@api/graphql/types-and-hooks";
import { invalidateReviewItems, settleReviewMutation } from "@components/QaReview/hooks/reviewMutations";
import { notifyError } from "@components/notifications/notifications";

export const useReopenComment = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useReopenReportCommentMutation({
    onSuccess: async (data) => {
      const toasts = { failure: "Failed to reopen comment", success: "Comment reopened successfully" };
      if (settleReviewMutation(data?.reopenReportComment, toasts)) await invalidateReviewItems(queryClient);
    },
    onError: () => notifyError("Error reopening comment. Please try again."),
  });

  return { reopen: (comment: ReviewItemFieldsFragment) => mutate({ id: comment.id }), isReopening: isPending };
};
